// @ts-check

import { onDomReady } from '../../utils/dom';
import { ElementsBlocker } from '../../vendor/ElementsBlocker/Blockers';

const elementsBlockerFolder = 'files/theme/js/modules/elementsBlocker';

function initializeBlocker() {

    new ElementsBlocker('.bild-blocker', {
        button: {
            content: 'Akzeptieren & Inhalte laden',
        },
        logo: {
            source: `${elementsBlockerFolder}/icons/pixabay.svg`,
            width: 150,
        },
        /* headline: {
            content: 'pixabay.de',
        }, */
        message: {
            content:
                'Klicken Sie hier, um Inhalte der Pixabay GmbH c/o Lacore Rechtsanwälte LLP zu laden. Wir möchten Sie darauf hinweisen, dass Daten (z. B. Ihre IP-Adresse) an die Pixabay GmbH c/o Lacore Rechtsanwälte LLP mit Sitz in Berlin, Deutschland übermittelt werden. Details in der <a href="datenschutz">Datenschutzerklärung</a>.',
        },
        caching: false,
        onSubmit: [
            (blockedElement) => {
                console.log(blockedElement);
                blockedElement.innerHTML =
                    '<img class="wikipedia-bild" src="https://cdn.pixabay.com/photo/2023/08/27/14/34/buildings-8217275_640.jpg" alt="Chemnitz" width="500">';
            },
        ],
    });
    new ElementsBlocker('.tippyloader-blocker', {
        button: {
            content: 'Akzeptieren & Inhalte laden',
        },
        logo: {
            source: `${elementsBlockerFolder}/icons/js.svg`,
            width: 150,
        },
        headline: {
            content: 'Javascript',
        },
        message: {
            content:
                'Klicken Sie, um die Javascripte popper.js und tippy.js von der Website https://unpkg.com, die in den USA gehostet wird, herunterzuladen und auszuführen. Wir möchten Sie darauf hinweisen, dass Daten (z. B. Ihre IP-Adresse) in die USA als einen datenschutzrechlich unsicheren Drittstaat übermittelt werden.',
        },
        caching: false,
        onSubmit: [
            'https://unpkg.com/@popperjs/core@2/dist/umd/popper.min.js',
            'https://unpkg.com/tippy.js@6.3.7/dist/tippy-bundle.umd.js',
            (blockedElement) => {
                let tippyText = document.createElement('p');
                tippyText.innerText =
                    'Die Javascripte wurden geladen. Wenn Sie die Maus über diesen Text über diesen Text bewegen, wird Ihnen ein Tooltipp von Tippy.js generiert.';
                blockedElement.append(tippyText);
                tippy(tippyText, { content: 'Tippy wurde asynchronus geladen' });
            },
        ],
    });

    new ElementsBlocker('.element-to-be-blocked .text_container', {
        headline: {
            content: "I'm Blocked",
        },
        button: {
            content: 'Accept',
        },
        onSubmit: [
            () => {
                alert('Accepted');
            },
            (element) => {
                element.innerText = "I'm unblocked now";
            },
        ],
    });
}

onDomReady(() => {
    initializeBlocker();
});
